function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
var HotKey = function () {
    function HotKey(player) {
        var _this = this;
        _classCallCheck(this, HotKey);
        this.template = player.template;
        this.container = player.template.hotkeyPanel;
        window.onresize = function () {
            var _player$highEnergy;
            player.resize();
            ((_player$highEnergy = player.highEnergy) === null || _player$highEnergy === void 0 ? void 0 : _player$highEnergy.isShow) && player.highEnergy.resize();
            if (!player.fullScreen.isFullScreen('browser') && !player.fullScreen.isFullScreen('web')) {
                player.fullScreen.cancel('browser');
                var danmakuRoot = player.template.danmakuRoot;
                if (_toConsumableArray(player.template.controllerWrap.childNodes).indexOf(danmakuRoot) > -1) {
                    player.template.controllerWrap.removeChild(danmakuRoot);
                    player.template.footBarWrap.appendChild(danmakuRoot);
                }
            }
        };
        if (player.options.hotkey) {
            document.addEventListener('keydown', function (e) {
                var _player$danmaku;
                if (player.focus) {
                    var tag = document.activeElement.tagName.toUpperCase();
                    var editable = document.activeElement.getAttribute('contenteditable');
                    var event = e || window.event;
                    if (event.keyCode === 13 && player.danmaku) {
                        var danmakuText = player.template.danmakuText.value;
                        if (danmakuText.trim()) {
                            player.danmaku.send({
                                size: player.controller.danmakuFontsize,
                                type: player.controller.danmakuType,
                                color: player.controller.danmakuColor,
                                text: danmakuText
                            });
                            player.template.danmakuText.value = '';
                            player.template.danmakuText.blur();
                        }
                    }
                    if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
                        var percentage;
                        console.log(event.keyCode);
                        switch (event.keyCode) {
                        case 27:
                            player.fullScreen.cancel('web');
                            break;
                        case 32:
                            event.preventDefault();
                            player.toggle();
                            break;
                        case 37:
                            event.preventDefault();
                            if (!player.options.draggable) {
                                break;
                            }
                            player.seek(player.video.currentTime - 5);
                            player.controller.setAutoHide();
                            break;
                        case 39:
                            event.preventDefault();
                            if (!player.options.draggable) {
                                break;
                            }
                            player.seek(player.video.currentTime + 5);
                            player.controller.setAutoHide();
                            break;
                        case 38:
                            event.preventDefault();
                            percentage = player.volume() + 0.1;
                            player.volume(percentage);
                            break;
                        case 40:
                            event.preventDefault();
                            percentage = player.volume() - 0.1;
                            player.volume(percentage);
                            break;
                        case 68:
                            event.preventDefault();
                            player === null || player === void 0 ? void 0 : (_player$danmaku = player.danmaku) === null || _player$danmaku === void 0 ? void 0 : _player$danmaku.toggle();
                            break;
                        case 70:
                            event.preventDefault();
                            player.fullScreen.toggle('browser');
                            break;
                        case 77:
                            event.preventDefault();
                            var videoVolume = player.volume();
                            if (player.video.muted) {
                                player.video.muted = false;
                                player.notice('已取消静音');
                                player.volume(videoVolume);
                            } else {
                                player.video.muted = true;
                                player.notice('已静音');
                                player.controller.components.volumeSlider.setValue(0);
                            }
                            break;
                        case 188:
                            player.switchVideo(player.currentVideo - 1);
                            break;
                        case 190:
                            player.switchVideo(player.currentVideo + 1);
                            break;
                        }
                    }
                }
            });
            this.template.hotkeyPanel.addEventListener('click', function (e) {
                e.stopPropagation();
            });
            this.template.hotkeyPanel.addEventListener('wheel', function (e) {
                e.stopPropagation();
            }, { passive: true });
            this.template.hotkeyPanelClose.addEventListener('click', function (e) {
                e.stopPropagation();
                _this.hide();
            });
        }
    }
    _createClass(HotKey, [
        {
            key: 'show',
            value: function show() {
                this.container.classList.remove('mfunsPlayer-hotkey-panel-hide');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.container.classList.add('mfunsPlayer-hotkey-panel-hide');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.container.classList.contains('mfunsPlayer-hotkey-panel-hide')) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
    ]);
    return HotKey;
}();
export {
    HotKey as default
};